import Model from '~/src/model.js';

class ExamAnswer extends Model {

  constructor(store) {
    super(store);
    this.modelName = 'exam_answers';
  }

  get(params = {}) {
    const query = this.objectToQuery(params);
    return new Promise((resolve, reject) => {
      this.axios.get(`/${this.modelName}/get?${query}`).then(({ data }) => {        
        this.data = data;
        resolve(data);
      }).catch((error) => {
        reject(error);
      });
    });
  }

}

export default ExamAnswer;
